export default __webpack_public_path__ + "static/media/cancelation_recshedule_policy.1da3df03.pdf";